var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Controller, useWatch, } from "react-hook-form";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { Row, Col, Datepicker, Button, Modal, ModalFooter, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import moment from "moment";
import { RecekTextField, RecekSelect } from "../inputs";
import { PublisherLegalFormEnum, PublisherOwnerEnum, } from "../../types/Api";
import { lookupPublisherByCompanyNumber, checkDuplicateCompanyNumber, } from "../../api/publisherService";
import styles from "./PublisherGeneralSection.module.css";
export var PublisherGeneralSection = function (_a) {
    var control = _a.control, errors = _a.errors, setValue = _a.setValue, trigger = _a.trigger, legalFormValue = _a.legalFormValue;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var companyNumber = useWatch({ control: control, name: "companyNumber" });
    var _b = useState(false), showDuplicateModal = _b[0], setShowDuplicateModal = _b[1];
    var _c = useState(false), errorModalOpen = _c[0], setErrorModalOpen = _c[1];
    var _d = useState(""), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useQuery(["companyNumber"], function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDuplicate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!companyNumber || companyNumber.length !== 8) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-legaldeposits.publishers.validation.companyNumber.format",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, checkDuplicateCompanyNumber(ky, companyNumber)];
                case 1:
                    isDuplicate = (_a.sent()).isDuplicate;
                    if (isDuplicate) {
                        setShowDuplicateModal(true);
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, lookupPublisherByCompanyNumber(ky, companyNumber)];
            }
        });
    }); }, {
        enabled: false,
        onSuccess: function (publisherData) {
            if (!publisherData)
                return;
            if (publisherData.name) {
                setValue("name", publisherData.name);
            }
            if (publisherData.nameSuffix) {
                setValue("nameSuffix", publisherData.nameSuffix);
            }
            if (publisherData.companyNumber) {
                setValue("companyNumber", publisherData.companyNumber);
            }
            if (publisherData.taxNumber) {
                setValue("taxNumber", publisherData.taxNumber);
            }
            if (publisherData.legalForm) {
                setValue("legalForm", publisherData.legalForm);
            }
            if (publisherData.mainAddress) {
                if (publisherData.mainAddress.street) {
                    setValue("mainAddress.street", publisherData.mainAddress.street);
                }
                if (publisherData.mainAddress.postalCode) {
                    setValue("mainAddress.postalCode", publisherData.mainAddress.postalCode);
                }
                if (publisherData.mainAddress.municipality) {
                    setValue("mainAddress.municipality", publisherData.mainAddress.municipality);
                }
                if (publisherData.mainAddress.regionId) {
                    setValue("mainAddress.regionId", publisherData.mainAddress.regionId);
                }
            }
        },
        onError: function () {
            setErrorMessage(formatMessage({
                id: "ui-br-legaldeposits.publishers.error.lookup",
            }));
            setErrorModalOpen(true);
        },
    }), isLookingUp = _e.isLoading, handleLookupCompanyNumber = _e.refetch;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "owner", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", labelId: "ui-br-legaldeposits.publishers.field.owner", disabled: true, dataOptions: [
                                {
                                    value: "",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.filter.select.all",
                                    }),
                                },
                                {
                                    value: PublisherOwnerEnum.LEGAL_DEPOSITS,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.owner.LEGAL_DEPOSITS",
                                    }),
                                },
                                {
                                    value: PublisherOwnerEnum.PUBLISHERS,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.owner.PUBLISHERS",
                                    }),
                                },
                            ] })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.name", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.nameSuffix" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement("div", { className: styles.icoWrapper },
                            React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.companyNumber", onBlur: function () {
                                    field.onBlur();
                                    trigger(["companyNumber", "taxNumber", "birthDate"]);
                                }, error: (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message, onChange: function (e) {
                                    field.onChange(e);
                                } })),
                            React.createElement(Button, { onClick: handleLookupCompanyNumber, disabled: isLookingUp }, isLookingUp
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.publishers.button.lookingUp",
                                })
                                : formatMessage({
                                    id: "ui-br-legaldeposits.publishers.button.lookupCompanyNumber",
                                }))));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.legalForm", required: true, dataOptions: [
                                {
                                    value: PublisherLegalFormEnum.LEGAL,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.legalForm.LEGAL",
                                    }),
                                },
                                {
                                    value: PublisherLegalFormEnum.NATURAL,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.legalForm.NATURAL",
                                    }),
                                },
                            ] })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.taxNumber" })));
                    } })),
            legalFormValue === PublisherLegalFormEnum.NATURAL && (React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(Datepicker, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : undefined, label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.birthDate",
                            }), backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", exclude: function (day) {
                                return day.isBefore(moment("1900-01-01", "YYYY-MM-DD")) ||
                                    day.isAfter(moment());
                            }, error: (_c = errors.birthDate) === null || _c === void 0 ? void 0 : _c.message })));
                    } })))),
        React.createElement(Modal, { open: showDuplicateModal, label: formatMessage({
                id: "ui-br-legaldeposits.publishers.modal.duplicate.title",
            }), footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: function () { return setShowDuplicateModal(false); } }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
            React.createElement("p", null, formatMessage({
                id: "ui-br-legaldeposits.publishers.modal.duplicate.message",
            }))),
        React.createElement(Modal, { open: errorModalOpen, label: formatMessage({
                id: "ui-br-legaldeposits.error.modal.title",
            }), footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
            React.createElement("p", null, errorMessage))));
};
